<template>
  <v-card>
    <v-card-title>
      {{ $t("auditor.closedAtForm.title") }}
    </v-card-title>

    <v-card-subtitle>
      {{ $t("auditor.closedAtForm.subtitle") }}
    </v-card-subtitle>

    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="6">
            <v-dialog ref="dateDialog" v-model="dateModal" :return-value.sync="date" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  :label="$t('auditor.closedAtForm.date.label')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.dateDialog.save(date)">{{ $t("action.ok") }}</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>

          <v-col cols="6">
            <v-dialog ref="timeDialog" v-model="timeModal" :return-value.sync="time" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="time"
                  :label="$t('auditor.closedAtForm.time.label')"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-time-picker v-if="timeModal" v-model="time" format="24hr" full-width>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="timeModal = false">{{ $t("action.cancel") }}</v-btn>
                <v-btn text color="primary" @click="$refs.timeDialog.save(time)">{{ $t("action.ok") }}</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="update" :disabled="closedAt === auditPeriod.closedAt" :loading="loading" color="secondary">
        {{ $t("auditor.closedAtForm.update") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UpdateAuditPeriodMutation from "@/gql/mutations/UpdateAuditPeriodMutation.gql";

export default {
  props: {
    auditPeriod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: false,
      loading: false,
      dateModal: false,
      timeModal: false,
      date: this.auditPeriod.closedAt.substr(0, 10),
      time: this.auditPeriod.closedAt.substr(11, 5),
    };
  },

  computed: {
    closedAt() {
      return `${this.date}T${this.time}:00.000Z`;
    },
  },

  methods: {
    async update() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;

      this.$apollo.mutate({
        mutation: UpdateAuditPeriodMutation,
        variables: {
          id: this.auditPeriod.id,
          input: {
            closedAt: this.closedAt,
          },
        },
      });

      this.loading = false;
    },
  },
};
</script>
